import React, {useMemo} from 'react';

import './styles.scss';
import {DataPoint} from '../../App';
import {useNavigate, useParams} from 'react-router-dom';
import Icon from '../Icon/Icon';
import {displayInvestment, getFriendlyProductStatus} from '../../utils';

interface FilteredDetailProps {
  data: DataPoint[];
}

const FilteredDetail = ({data}: FilteredDetailProps) => {
  // Grouped by type for EU view, grouped by country for CN view
  const groupedLinks: {
    [key: string]: DataPoint[];
  } = {};

  const navigate = useNavigate();
  const params = useParams();
  const {view} = params;

  data.forEach((dataPoint) => {
    const type = dataPoint.Investor_country;
    if (!groupedLinks[type]) {
      groupedLinks[type] = [];
    }
    groupedLinks[type].push(dataPoint);
  });


  const openLinkDetail = (data: DataPoint) => {
    navigate(`/map/${data.id}`);
  };

  if (!data) return <div className="message-box">Loading...</div>;
  if (!data[0]) return <div className="message-box">No data</div>;

  return (
    <div className={`FilteredDetail`}>
      <>
        <p className="title">Filtered data</p>
        <div>
          {Object.keys(groupedLinks).map((type) => {
            const data = groupedLinks[type];
            const sortedData = data.sort((a, b) => {
              return a.Entity.localeCompare(b.Entity);
            });
            return (
              <div key={type} className="link">
                <p className="city-name">{type}</p>
                {sortedData.map((link) => {
                  const entity = link.Entity.trim();
                  const amount = link.Amount_EUR_mln.trim();
                  const location = link.Location.trim();

                  return (
                    <a onClick={() => openLinkDetail(link)} key={link.id}>
                      <Icon type={link.Category} width={16} />
                      <span>
                        <b>{entity}</b> ({displayInvestment(link.Amount_EUR_mln)}), {location}, {getFriendlyProductStatus(link.Production_status)}
                      </span>
                    </a>
                  );
                })}
              </div>
            );
          })}
        </div>
      </>
    </div>
  );
};

export default FilteredDetail;
